module.exports = __webpack_public_path__ + "img/in.e2e03644.svg";